import { ViewerModule } from "@g.frame/core";
import { CylinderBufferGeometry, Group, Mesh, MeshBasicMaterial } from "three";
export default class Water extends ViewerModule {
    constructor() {
        super();
        this.mainContainer = new Group;
        this.addObject(this.mainContainer);
    }
    init(size) {
        if (!this.waterCylinder) {
            this.waterCylinder = new Mesh(new CylinderBufferGeometry(size.x, size.x, size.y, 24, 1).translate(0, -size.y / 2, 0), new MeshBasicMaterial({ transparent: true, opacity: 0.4, color: '#9999ee', depthFunc: 1 }));
            this.mainContainer.add(this.waterCylinder);
        }
    }
    updateWater(scale) {
        this.waterCylinder && this.waterCylinder.scale.set(1, scale, 1);
    }
    bubbles() {
    }
}
